import { useNavigate } from '@remix-run/react';
import { AlertTriangle } from 'lucide-react'; // Using an icon for warning
import { useStorageStatus } from '~/hooks/useStorageStatus';

export function StorageManagementButton({
  setIsStorageExceededModalOpen,
}: {
  setIsStorageExceededModalOpen: (isOpen: boolean) => void;
}) {
  const navigate = useNavigate();
  const { showStorageWarning } = useStorageStatus();

  if (!showStorageWarning) {
    return null;
  }

  return (
    <button
      onClick={() => {
        setIsStorageExceededModalOpen(true);
      }}
      className="flex items-center gap-2 cursor-pointer hover:bg-yellow-600 text-white px-4 py-2 rounded-full text-sm transition-colors duration-150 border border-yellow-600 shadow-md whitespace-nowrap"
      title="Storage usage is high. Click to manage."
    >
      <AlertTriangle className="w-4 h-4" />
    </button>
  );
}
